import { createSlice } from '@reduxjs/toolkit';
import {
  createClientThunk,
  deleteClientThunk,
  editClientThunk,
  getBasketRoutingOptionsThunk,
  getMyClientsThunk,
  getSelectedClientThunk,
} from './myClientsActions';

export interface MyClientsState {
  loading: boolean;
  data: any;
  selectedClientData: any;
  basketRoutingOptions?: any;
}

const initialState: MyClientsState = {
  loading: false,
  data: null,
  selectedClientData: null,
  basketRoutingOptions: null,
};

const myClientsSlice = createSlice({
  name: 'My Clients',
  initialState,
  reducers: {
    clearSelectedClientData: (state) => {
      state.selectedClientData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyClientsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyClientsThunk.fulfilled, (state, action) => {
        state.data = action.payload?.data?.allBnyClients || [];
        state.loading = false;
      })
      .addCase(getMyClientsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getSelectedClientThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSelectedClientThunk.fulfilled, (state, action) => {
        state.selectedClientData = action.payload || null;
        state.loading = false;
      })
      .addCase(getSelectedClientThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getBasketRoutingOptionsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBasketRoutingOptionsThunk.fulfilled, (state, action) => {
        const options = action?.payload
          ?.find((option) => option.tableName === 'Basket Routing')
          ?.lookupValues?.map((o) => ({ routingName: o.value, routingCode: o.valueId }));
        state.basketRoutingOptions = options || null;
        state.loading = false;
      })
      .addCase(getBasketRoutingOptionsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editClientThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editClientThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editClientThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createClientThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createClientThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createClientThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteClientThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteClientThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteClientThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearSelectedClientData } = myClientsSlice.actions;
export default myClientsSlice.reducer;
